import React from 'react';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import { Label } from 'reactstrap';
import { checkNullValue, checkNumberValue } from '../utils/Util';

interface IBasicDetailsProps {
  user?: any;
}

const ViewRemunerationDetails: React.FunctionComponent<IBasicDetailsProps> = ({
  user,
}) => {
  const getProfileDetails = () => (
    <div className="mt-4 mb-2 pb-2 mx-4 remuneration-modal-detaild">
      <div className="p-3 pt-0">
        <Row>
          <Col xs={6} md={3}>
            <Label className="mb-0 model-label-name">Employee Id</Label>
            <br />
            <Label className="mb-0 model-label-value">
              {checkNullValue(user?.employeeUniqueId)}
            </Label>
          </Col>
          <Col xs={6} md={3}>
            <Label className="mb-0 model-label-name">Employee Name</Label>
            <br />
            <Label className="mb-0 model-label-value">
              {checkNullValue(user?.candidateName)}
            </Label>
          </Col>
          <Col xs={6} md={3}>
            <Label className="mb-0 model-label-name">Role</Label>
            <br />
            <Label className="mb-0 model-label-value">
              {' '}
              {checkNullValue(user?.roleNames)}
            </Label>
          </Col>
          <Col xs={6} md={3}>
            <Label className="mb-0 model-label-name">Grid Location</Label>
            <br />
            <Label className="mb-0 model-label-value">
              {' '}
              {checkNullValue(user?.assignedGrids)}
            </Label>
          </Col>
        </Row>
        <Row className="mt-2">
          <Col xs={6} md={2}>
            <Label className="mb-0 model-label-name">Zone</Label>
            <br />
            <Label className="mb-0 model-label-value">
              {checkNullValue(user?.zoneName)}
            </Label>
          </Col>
          <Col xs={6} md={2}>
            <Label className="mb-0 model-label-name">State</Label>
            <br />
            <Label className="mb-0 model-label-value">
              {checkNullValue(user?.stateName)}
            </Label>
          </Col>
          <Col xs={6} md={3}>
            <Label className="mb-0 model-label-name">District</Label>
            <br />
            <Label className="mb-0 model-label-value">
              {checkNullValue(user?.districtName)}
            </Label>
          </Col>
          <Col xs={6} md={3}>
            <Label className="mb-0 model-label-name">City / village</Label>
            <br />
            <Label className="mb-0 model-label-value">
              {checkNullValue(user?.cityName)}
            </Label>
          </Col>
          <Col xs={6} md={2}>
            <Label className="mb-0 model-label-name">Pincode</Label>
            <br />
            <Label className="mb-0 model-label-value">
              {checkNullValue(user?.pincode)}
            </Label>
          </Col>
        </Row>
      </div>
      <hr />
      <div className="p-3">
        <div className="d-flex justify-content-between">
          <p className="modal-remuneration-header mb-0">Total sales</p>
        </div>
        <Row className="">
          <Col xs={6} md={4}>
            <Label className="mb-0 model-label-name">Prakriti Sales</Label>
            <br />
            <Label className="mb-0 model-label-value">
              {checkNullValue(user?.prakritiSalesCount)}
            </Label>
          </Col>
          <Col xs={6} md={4}>
            <Label className="mb-0 model-label-name">Sukriti Sales </Label>
            <br />
            <Label className="mb-0 model-label-value">
              {checkNullValue(user?.sukritiSalesCount)}
            </Label>
          </Col>
        </Row>
      </div>
      <hr />
      <div className="p-3">
        <div className="d-flex justify-content-between">
          <p className="modal-remuneration-header mb-0">Total Leads</p>
        </div>
        <Row className="">
          <Col xs={6} md={4}>
            <Label className="mb-0 model-label-name">Leads Created</Label>
            <br />
            <Label className="mb-0 model-label-value">
              {checkNumberValue(user?.leadsCreatedCount)}
            </Label>
          </Col>

          <Col xs={6} md={4}>
            <Label className="mb-0 model-label-name">Leads Closed</Label>
            <br />
            <Label className="mb-0 model-label-value">
              {checkNumberValue(user?.leadsClosedCount)}
            </Label>
          </Col>
        </Row>
      </div>
      <hr />
      <div className="p-3">
        <div className="d-flex justify-content-between">
          <p className="modal-remuneration-header mb-0">Total Tasks</p>
        </div>
        <Row className="">
          <Col xs={6} md={4} className="mb-3">
            <Label className="mb-0 model-label-name">CHM Count</Label>
            <br />
            <Label className="mb-0 model-label-value">
              {checkNumberValue(user?.chmCount)}
            </Label>
          </Col>
          <Col xs={6} md={4}>
            <Label className="mb-0 model-label-name">Survey Count</Label>
            <br />
            <Label className="mb-0 model-label-value">
              {checkNumberValue(user?.surveyCount)}
            </Label>
          </Col>
          <Col xs={6} md={4}>
            <Label className="mb-0 model-label-name">Farmer Registration</Label>
            <br />
            <Label className="mb-0 model-label-value">
              {checkNumberValue(user?.appRegistrationCount)}
            </Label>
          </Col>
          <Col xs={6} md={4}>
            <Label className="mb-0 model-label-name">IEC Count</Label>
            <br />
            <Label className="mb-0 model-label-value">
              {checkNumberValue(user?.iecCount)}
            </Label>
          </Col>
          <Col xs={6} md={4}>
            <Label className="mb-0 model-label-name">CCE Count</Label>
            <br />
            <Label className="mb-0 model-label-value">
              {checkNumberValue(user?.cceCount)}
            </Label>
          </Col>
          <Col xs={6} md={4}>
            <Label className="mb-0 model-label-name">Draw Polygon Count</Label>
            <br />
            <Label className="mb-0 model-label-value">
              {checkNumberValue(user?.drawPolygonCount)}
            </Label>
          </Col>
          <Col xs={6} md={4}>
            <Label className="mb-0 model-label-name">
              Sales Activity Count
            </Label>
            <br />
            <Label className="mb-0 model-label-value">
              {checkNumberValue(user?.marketingActivityCount)}
            </Label>
          </Col>
        </Row>
      </div>
      <hr />
      <div className="p-3">
        <div className="d-flex justify-content-between">
          <p className="modal-remuneration-header mb-0">Total Complaints</p>
        </div>
        <Row className="">
          <Col xs={6} md={4}>
            <Label className="mb-0 model-label-name">Complaints Raised</Label>
            <br />
            <Label className="mb-0 model-label-value">
              {checkNumberValue(user?.complaintsRaisedCount)}
            </Label>
          </Col>
          <Col xs={6} md={4}>
            <Label className="mb-0 model-label-name">
              Complaints Closed Count 
            </Label>
            <br />
            <Label className="mb-0 model-label-value">
              {checkNumberValue(user?.complaintsClosedCount)}
            </Label>
          </Col>
        </Row>
      </div>
      <hr />
    </div>
  );
  return getProfileDetails();
};

export default ViewRemunerationDetails;
